import { KycCurrentStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';
import { isProcessStatusPendingLiveness } from './is-process-status-pending-liveness';
import { isKycSubmitted } from './is-kyc-submitted';

export function shouldSkipKyc(kycInfo: KycResponse | null, isRegisterFlow?: boolean): boolean {
  if (!kycInfo) return false;

  const isKycAccepted =
    !kycInfo.activeProcess && kycInfo.kycCurrentStatus === KycCurrentStatus.accepted;

  const shouldSkipKycBase = isKycAccepted || isKycSubmitted(kycInfo);

  if (isRegisterFlow) {
    const hasActiveProcessNotPendingLiveness =
      Boolean(kycInfo.activeProcess) && !isProcessStatusPendingLiveness(kycInfo);
    return shouldSkipKycBase || hasActiveProcessNotPendingLiveness;
  }

  return shouldSkipKycBase;
}
